<template>
  <v-flex xs2 sm2 md2 lg2 xl2 data-qa="idletimeout-flex-swovwh">
    <Modal :config="modalConfig" @btn1Action="continueSession" @btn2Action="logout">
      <span slot="modalContent" data-qa="idle-timeout-progress">
        <div class="text-center">
          <v-progress-circular
            :value="(value / countdownTimer) * 100"
            :rotate="-90"
            :size="180"
            :width="10"
            :color="secondaryColor"
            style="transform: scaleX(-1)"
          >
          <div class="mt-6 d-flex flex-column align-center" style="color: black;">
            <span class="text-h3 font-weight-regular" style="transform: scaleX(-1)">{{ value }}</span>
            <span style="font-size: 1rem; transform: scaleX(-1)"><span>{{ $t("common.sessionTimeOutLabel") }}</span></span>
          </div>
          </v-progress-circular>
        </div>
      </span>
    </Modal>
  </v-flex>
</template>

<script>
import IdleVueComponent from 'idle-vue/src/components/Idle.vue'
import Vue from 'vue'
import event from '@/util/event'
import store from '@/core/store'

Vue.component('idle-view', IdleVueComponent)
export default {
  name: 'idle-timeout',
  components: {
    Modal: () => import('@/components/common/Modal.vue')
  },
  data () {
    return {
      value: Math.round(this.$appSettings.defaultConfigurations.countdownTimer / 1000),
      intervalId: null,
      isLoggedOut: false,
      stopCountdown: false,
      timeoutFired: false,
      modalConfig: {
        enabled: false,
        outlinedSaveBtn: false,
        icon: 'mdi-timer',
        persistent: true,
        btn1Label: this.$t('common.continueSessionBtn'),
        btn2Label: this.$t('common.logoutNowBtn'),
        subtitle: this.$t('common.sessionTimeOutContent'),
        title: this.$t('common.sessionTimeOutTitle'),
        width: 450
      },
      countdownTimer: Math.round(Math.min(this.$appSettings.defaultConfigurations.countdownTimer, this.$appSettings.defaultConfigurations.idleTimeoutInterval) / 1000)
    }
  },
  beforeDestroy () {
    this.clearCountdown()
  },
  methods: {
    startCountdown () {
      this.clearCountdown()
      this.timeoutFired = false

      const startTime = Date.now()
      const duration = this.value * 1000

      const tick = () => {
        if (this.stopCountdown) return

        const elapsed = Date.now() - startTime
        const remaining = Math.max(0, duration - elapsed)
        this.value = Math.ceil(remaining / 1000)

        if (remaining <= 0 && !this.timeoutFired) {
          this.timeoutFired = true
          this.clearCountdown()
          this.sessionTimeout()
        } else {
          requestAnimationFrame(tick)
        }
      }
      requestAnimationFrame(tick)
    },
    clearCountdown () {
      if (this.intervalId) {
        clearInterval(this.intervalId)
        this.intervalId = null
      }
    },
    logout () {
      event.$emit('consentScreenIsOpen', false)
      store.dispatch('profileStore/setProfileData', { logout: true })
      this.$route.path !== '/login' && this.$router.push('/login')
    },
    sessionTimeout () {
      event.$emit('consentScreenIsOpen', false)
      store.dispatch('profileStore/setProfileData', { logout: true })
      this.$route.path !== '/login' && this.$router.push({ name: 'Login', params: { from: 'IdleTimeout' } })
    },
    continueSession () {
      this.stopCountdown = true
      this.modalConfig.enabled = false
      store.dispatch('profileStore/setProfileData', { logout: false })
      this.value = this.countdownTimer
    }
  },
  onIdle () {
    this.modalConfig.enabled = true
    store.dispatch('profileStore/setProfileData', { logout: false })
    this.value = this.countdownTimer
    if (this.countdownTimer <= 0) this.sessionTimeout()
    this.stopCountdown = false
    this.startCountdown()
  }
}
</script>
